import React from 'react';
import './ReissueNoticeModal.css';
import { useTranslation } from 'react-i18next';
import Modal from 'components/Modal';

interface ReissueNoticeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onGoToBranchListClick: () => void;
}

const ReissueNoticeModal: React.FC<ReissueNoticeModalProps> = ({isOpen, onClose, onGoToBranchListClick}) => {

  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen}
           contentLabel="modal"
           className="reissueNoticeModalOverlay"
           overlayClassName="dim"
           closeTimeoutMS={500}
           preventBackgroundScroll onRequestClose={onClose}>
      <div className={"reissueNoticeModal"}>
        <div className={'reissueNoticeContent'}>
          <p className={'reissueNoticeTitle'}>{t('STAT01.TEXT_10', 'Reissue Notice')}</p>
          <p className={'reissueNoticeDescription'}>{t('STAT01.TEXT_11', 'Please visit branch to receive a new card and register it.')}</p>
        </div>
        <div className={'reissueNoticeButtonWrap'}>
          <button
            type="button"
            className="activeButton"
            onClick={onGoToBranchListClick}>
            <p>{t('STAT01.TEXT_12', 'Go to Branch List')}</p>
          </button>
          <button
            type="button"
            className="closeButton"
            onClick={onClose}>
            <p>{t('STAT01.TEXT_13', 'Close')}</p>
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default ReissueNoticeModal;